import Navbar from '../../components/layout/Navbar';
import ReportesDinamicos from '../../components/sections/ReportesDinamicos';
import Footer from '../../components/layout/Footer';

export default function ReportesPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar activeSection="reportes" />

      <main className="pt-16">
        <ReportesDinamicos />
      </main>

      <Footer />
    </div>
  );
}